import {StoreType} from '../../../types/sharedTypes';

export const isLoggedInSelector = (state: StoreType) => {
  return state.sessionReducer.loggedIn;
}
